//#region Styles
import {
	Row,
	Column,
	Part,
	TitleSection,
	SubtitleSection,
	ParagraphSection,
	Fields,
} from "components/styles";
//#endregion
//#region Components
import CustomSelect from "components/CustomSelect/CustomSelect";
import NotificationNoContent from "components/NotificationNoContent/NotificationNoContent";
import CustomRenderSelect from "components/CustomRenderSelect/CustomRenderSelect";
import EventGraphicOption from "./components/EventGraphicOption/EventGraphicOption";
import ImageOption from "../../../../../../../../../../components/CustomRenderSelect/components/ImageOption/ImageOption";
//#endregion
//#region Services
//#endregion
//#region Utils
import useEventFormContext from "views/Eventos/components/FormCreateEvent/ManualLoadingForm/utils/context/useEventFormContext";
import useObserveEventTypeId from "./utils/hooks/useObserveEventTypeId";
import useObserveEventSubtypeId from "./utils/hooks/useObserveEventSubtypeId";
import { eventsSessionStorage } from "services/storage/events";
import { useEffect, useRef, useState } from "react";
import { EVENTS_CONSTANTS } from "config/constants";
//#endregion

const Part2 = ({
	form,
	// changeFieldPart1,
	changeField,
	changeFieldPart3,
	errors,
	eventResumeData,
	changePayGradeField,
	setSelectedCourseName
	//setIsCulturalOrSport
}) => {
	//#region Extra Hooks
	const { eventTypeId, eventSubtypeId, sectionSubtype } = form;
	const { data, isCreate, isWorkshopEventType } = useEventFormContext();
	const { eventTypes, eventSubtypes, eventGraphics, extracurricularSections } = data;
	const [primerValorSeccion, setPrimerValor] = useState(undefined);
	
	//#endregion
	//#region Effects
	useObserveEventTypeId({
		eventTypeId,
		eventSubtypeId,
		areNotEventSubtypes,
		areNotSectionSubtype,
		changeEventSubtypeId,
		changeSectionSubtypeId,
		changeEventGraphicId,
		changePayGradeField,
		changeComplementaryServiceAreaId,
		changePeriod,
		eventResumeData,
	});
	useObserveEventSubtypeId({
		eventSubtypeId,
		changeEventGraphicId,
	});
	useEffect(() => {
		if ((primerValorSeccion === undefined || primerValorSeccion == 0) && sectionSubtype !== 0) {
		  setPrimerValor(sectionSubtype); // Guarda solo la primera vez
		}

	}, [sectionSubtype]);
	//#endregion
	//#region Functions
	const filterEventGraphics = () => {
		return eventGraphics.filter(eventGraphic => {
			return (
				(eventGraphic.eventTypeId === eventTypeId &&
					eventGraphic.eventSubtypeId === eventSubtypeId) ||
				(eventGraphic.eventTypeId === eventTypeId &&
					eventGraphic.eventSubtypeId === null)
			);
		});
	};
	const renderEventGraphicField = () => {
		const currentEventGraphics = filterEventGraphics();
		if (currentEventGraphics.length === 0)
			return (
				<NotificationNoContent
					title="Aún no has señalado un tipo de evento"
					description="Selecciona uno para mostrarte las gráficas"
				/>
			);
		return (
			<Row className="flex-start">
				<CustomRenderSelect
					optionsProps={currentEventGraphics.map(
						({ id, image, name }) => {
							return {
								currentValue: id,
								title: name,
								src: image,
							};
						}
					)}
					render={EventGraphicOption}
					value={form.eventGraphicId}
					onClick={changeEventGraphicId}
					errorText="Es necesario seleccionar una gráfica para tu evento"
					error={errors.eventGraphicId}
				/>
			</Row>
		);
	};
	const areThereEventSubtypes = () => {
		return eventSubtypes.some(
			eventSubtype => eventSubtype.eventTypeId === eventTypeId
		);
	};

	const areThereSectionsEventSubtypes = () => {
		return extracurricularSections.some(
			section => section.idSubTipoEvento === eventSubtypeId
		);
	};
	function areNotEventSubtypes() {
		const value = !eventSubtypes.some(
			eventSubtype => eventTypeId === eventSubtype.eventTypeId
		);
		changeField("hasSubtype", !value);
		return value;
	}
	function areNotSectionSubtype(){
		const value = !extracurricularSections.some(
			section => section.idSubTipoEvento === eventSubtypeId
		);
		changeField("hasSectionSubtype", !value);
		return value;
	}
	function changePeriod(value) {
		changeFieldPart3("period", value);
	}
	const changeEventTypeId = value => {
		changeField("eventTypeId", value, false);
	};
	function changeEventSubtypeId(value) {
		//setIsCulturalOrSport(value == EVENTS_CONSTANTS.EVENT_SUBTYPES.CULTURAL || value == EVENTS_CONSTANTS.EVENT_SUBTYPES.SPORT)
		changeField("eventSubtypeId", value, false);
	}
	function changeSectionSubtypeId(value) {
		// const selectedCourse = '';

		if(value!=0){
			const selectedCourse = extracurricularSections.find(
				(course) => course.courseCode === value
			);
			setSelectedCourseName(selectedCourse.courseName)
			// changeFieldPart1("title",selectedCourse.courseName, false);
		}
		
		changeField("sectionSubtype", value, false);
	}
	function changeComplementaryServiceAreaId(value) {
		changeField("complementaryServiceAreaId", value, false);
	}
	function changeEventGraphicId(value) {
		changeField("eventGraphicId", value, false);
	}
	function hasBeenSelectedWorkshopEventTypeAndIsNotDraft() {
		/*
		El campo "eventType" debe ser deshabilitado cuando ya no es borrador, debido a que la duración ya no debe ser modificada para no alterar la gestión interna de los horarios en PS.
		*/
		return (
			!isCreate &&
			!eventsSessionStorage.isDraftEvent.get() &&
			isWorkshopEventType
		);
	}
	//#endregion
	return (
		<Part>
			<Fields>
				<Row>
					<Column
						width="40%"
						gap="5px"
					>
						<TitleSection>Tipo de evento:</TitleSection>
						<ParagraphSection>
							Selecciona una opción
						</ParagraphSection>
						<CustomRenderSelect
							optionsProps={eventTypes.map(item => {
								return {
									currentValue: item.id,
									title: item.name,
									src: item.icon,
								};
							})}
							render={ImageOption}
							value={eventTypeId}
							onClick={changeEventTypeId}
							disabled={hasBeenSelectedWorkshopEventTypeAndIsNotDraft()}
							error={errors.eventTypeId}
							errorText="Es necesario seleccionar un tipo de evento"
						/>
					</Column>
					<Column
						width="30%"
						gap="20px"
					>
						{areThereEventSubtypes() && (
								<CustomSelect
									label="Subtipo de evento:"
									direction="row"
									value={eventSubtypeId}
									onChange={changeEventSubtypeId}
									defaultOptionText="Selecciona un subtipo"
									optionsProps={eventSubtypes.map(
										({ id, name }) => {
											return {
												value: id,
												text: name,
											};
										}
									)}
									error={errors.eventSubtypeId}
									errorText="Es necesario seleccionar un subtipo"
								/>
							)}	
						{areThereSectionsEventSubtypes() && (
								<CustomSelect
									label="Curso Extracurricular :"
									direction="row"
									value={sectionSubtype}
									onChange={changeSectionSubtypeId}
									defaultOptionText="Selecciona un curso"
									optionsProps={extracurricularSections
										//.filter(x => (!sectionSubtype && x.visible) || (sectionSubtype))										
										// .filter(x => x.visible || x.seccionExtracurricularId === primerValorSeccion || x.seccionExtracurricularId === sectionSubtype)
										.map(({ courseCode, courseName }) => ({
											value: courseCode,
											text: `${courseName}`,
										}))}
									error={errors.sectionSubtype}
									errorText="Es necesario seleccionar una sección"
								/>							
							)}	
					</Column>					
				</Row>
				<Column>
					<SubtitleSection>Gráfica para evento</SubtitleSection>
					<ParagraphSection>
						Selecciona la gráfica que ayudará al estudiante a
						identificar tu evento
					</ParagraphSection>
					{renderEventGraphicField()}
				</Column>
			</Fields>
		</Part>
	);
};

export default Part2;
